// src/i18n/translations/uk.js
const translations = {
  brand: "Марка",
  category: "Категорія",
  type: "Тип",
  cargo_capacity: "Багажний простір",
  seats: "Місця",
  created_at: "Дата створення",
  updated_at: "Дата оновлення",
  id: "ID",
  user_id: "ID користувача",
  invoices: "Рахунки",
  vehicle: "Мої автомобілі",
  transfer_all: "Огляд усіх поїздок",
  transfer_new: "Нові поїздки",
  transfer_assign: "Призначити водія",
  vatIdLabel: "VAT-номер клієнта",
  bookingAs: "Бронюю як",
  privatePerson: "Приватна особа",
  companyOption: "Компанія",
  companyName: "Назва компанії",
  vatIdOptional: "VAT-номер (необов'язково)",
  vatIdInvalid: "Невірний VAT-номер (напр. DE123456789)",
  receiptHint: "Для квитанції/рахунку",
  transfer_close: "До завершення",
  completeTrip: "Завершити",
  completeTripConfirm: "Завершити поїздку? Клієнт отримає лист із подякою та квитанцію; оплату буде позначено як сплачену.",
  instantConfirmed: "Миттєве підтвердження",
  ratingFilter: "Оцінка",
  allRatings: "Усі оцінки",
  starsAndUp: "зірок і більше",
  instantHint: "Миттєве підтвердження: бронювання підтверджується одразу",
  transfer_today: "Сьогоднішні поїздки",
  transfer_tomorrow: "Завтрашні поїздки",
  transfer_current: "Поточні поїздки",
  transfer_storno: "Скасовані поїздки",
  transfer_reklamiert: "Поїздки зі скаргами",
  transfer_noshow: "Неявка",
  transfer_finished: "Завершені поїздки",
  transfer_all_admin: "Огляд усіх поїздок",
  transfer_new_admin: "Нові поїздки",
  transfer_today_admin: "Сьогоднішні поїздки",
  transfer_tomorrow_admin: "Завтрашні поїздки",
  transfer_current_admin: "Поточні поїздки",
  transfer_storno_admin: "Скасовані поїздки",
  transfer_reklamiert_admin: "Поїздки зі скаргами",
  transfer_noshow_admin: "Неявка",
  transfer_finished_admin: "Завершені поїздки",
  driver: "Мої водії",
  first_name: "Ім'я",
  last_name: "Прізвище",
  pickup_datetime: "Дата / час подачі",
  status: "Статус",
  total_price: "Загальна вартість",
  route: "Звідки → Куди",
  payment_method: "Спосіб оплати",
  currency: "Валюта",
  invoice_status: "Рахунок",
  data: "Моя компанія",
  company_active: "Користувач активовано",
  logo: "Завантаження логотипу компанії",
  company_name: "Назва компанії",
  company_legal_form: "Організаційно-правова форма",
  company_register_number: "Номер у торговому реєстрі",
  company_street: "Адреса",
  company_zip: "Індекс",
  company_country: "Країна",
  company_city: "Місто",
  company_tax_number: "Податковий номер",
  company_vat_id: "Номер платника ПДВ",
  company_phone: "Номер телефону (робочий)",
  company_email: "Електронна адреса (робоча)",
  company_website: "Веб-сайт",
  licence: "Завантаження ліцензії",
  company_licence: "Ліцензія наявна?",
  company_licence_expiration: "Дата закінчення ліцензії?",
  prices: "Ступеневі тарифи",
  bis10km: "Розрахована ціна за км до 10 км",
  bis20km: "Розрахована ціна за км до 20 км",
  bis50km: "Розрахована ціна за км до 50 км",
  bis100km: "Розрахована ціна за км до 100 км",
  ab100km: "Розрахована ціна за км від 100 км",
  citys: "Обслуговувані міста",
  getpartner: "Стати партнером",
  partnerlogin: "Вхід для партнерів",
  editbooking: "Керувати бронюванням",
  contact: "Контакти",
  booknow: "Забронювати зараз",
  oneway: "Тільки в один бік",
  roundtrip: "Туди й назад",
  flughafentransfer: "Трансфер до аеропорту",
  ConvenientAndOnTime: "Вчасно. Комфортно.",
  yourTransfer: "Ваш трансфер.",
  bnHeadline: "Куди сьогодні поїдемо?",
  bnSub: "Трансфер до аеропорту за фіксованою ціною – бронювання за кілька кліків",
  bnPopular: "Популярні маршрути",
  bnRoute1: "Кельн → Аеропорт Дюссельдорф",
  bnRoute2: "Ессен → Аеропорт Дюссельдорф",
  bnRoute3: "Дюссельдорф → Аеропорт Кельн/Бонн",
  bnRoute4: "Бонн → Аеропорт Франкфурт",
  moBestRated: "Найкращі оцінки",
  moRecommended: "Рекомендовано",
  moAll: "Усі",
  moDetails: "Деталі",
  moLess: "Менше",
  moOffersN: "{n} пропозицій",
  moOfferOne: "1 пропозиція",
  moFrom: "від",
  moPicksTitle: "Наш вибір для вас",
  moCheapest: "Найдешевші",
  guideHello: "Привіт, куди їдемо?",
  guideTitle1: "Ваш трансфер",
  guideTitle2: "у 3 кроки",
  guideStepRoute: "Маршрут",
  guideStepDate: "Дата",
  guideStepOffer: "Пропозиція",
  guideRoute: "Ваш маршрут",
  guideWhen: "Коли?",
  guideToday: "Сьогодні",
  guideTomorrow: "Завтра",
  guidePick: "Дата",
  guidePickupTime: "Час подачі",
  guideReturn: "Додати поїздку назад",
  uberHeadline: "Ваш трансфер – куди завгодно",
  privateTransferDescription: "Приватний трансфер за фіксованими цінами – від дверей до дверей, без сюрпризів.",
  bookRide: "Забронювати поїздку",
  destination: "Пункт призначення",
  enterDestinationAddress: "Введіть адресу призначення",
  returnTrip: "Зворотна поїздка",
  outboundTrip: "Поїздка в один бік",
  paymentMethods: "Способи оплати",
  loading: "Завантаження…",
  showOffers: "Показати пропозиції",
  rides: "Поїздки",
  customerRating: "Оцінка клієнта",
  vehicles: "Автомобілі",
  support: "Підтримка",
  recentSearches: "Останні пошуки",
  departure: "Відправлення",
  enterStartAddress: "Введіть адресу відправлення",
  swapAddresses: "Поміняти адреси місцями",
  whyGoTransfer24: "Чому GoTransfer24",
  clearBenefits: "Явні переваги",
  atAGlance: "одним поглядом.",
  fairFixedPricesTitle: "Чесні фіксовані ціни",
  fairFixedPricesDescription: "Без лічильника, без ризику. Ціна визначається до бронювання – прозоро та гарантовано.",
  bookedIn60SecondsTitle: "Бронювання за 60 секунд",
  bookedIn60SecondsDescription: "Початок, пункт призначення, авто – готово. Без реєстрації, без паперової тяганини, без очікування.",
  flexiblePaymentTitle: "Гнучка оплата",
  flexiblePaymentDescription: "PayPal, кредитна картка або готівка водію. Ви обираєте, що вам зручніше.",
  verifiedDriversTitle: "Перевірені водії",
  verifiedDriversDescription: "Усі водії ліцензовані та особисто перевірені. Пунктуальність і професіоналізм гарантовані.",
  available247Title: "Доступність 24/7",
  available247Description: "Ранній рейс о 4 ранку? Не проблема. Ми з вами цілодобово.",
  luggageExtrasTitle: "Багаж і додаткові послуги",
  luggageExtrasDescription: "Дитяче крісло, багато багажу, домашня тварина – все можна забронювати. Просто додайте під час оформлення.",
  chooseRoute: "Обрати маршрут",
  selectTripType: "Оберіть в один бік чи туди-назад",
  enterAddresses: "Введіть адреси відправлення та призначення",
  setDateTime: "Встановити дату й час",
  chooseVehicle: "Обрати автомобіль",
  compareOffersPrices: "Порівняти пропозиції та ціни",
  selectVehicle: "Обрати відповідний автомобіль",
  enterDetails: "Ввести дані",
  enterPassengerDetails: "Ввести дані пасажира",
  addFlightInformation: "Додати інформацію про рейс",
  selectExtras: "Обрати додаткові послуги",
  confirmation: "Підтвердження",
  selectPaymentMethod: "Обрати спосіб оплати",
  receiveBookingConfirmation: "Отримати підтвердження бронювання",
  businessAirportTransfer: "Бізнес-трансфер до аеропорту",
  economyAirportTransfer: "Економ-трансфер до аеропорту",
  luxuryAirportTransfer: "Люкс-трансфер до аеропорту",
  vipSprinterTransfer: "VIP Sprinter трансфер",
  faqPriceQuestion: "Скільки коштує трансфер до аеропорту з GoTransfer24?",
  faqPriceAnswer: "Ціна залежить від маршруту, дати та обраного класу автомобіля і відображається як фіксована ціна до завершення бронювання. Додаткова плата за затори, нічну поїздку чи звичайний багаж не стягується.",
  faqAdvanceBookingQuestion: "За скільки часу слід бронювати?",
  faqAdvanceBookingAnswer: "Бронювання можливе навіть у короткий термін, однак ми рекомендуємо не менше 24 годин заздалегідь – особливо у високий сезон чи свята.",
  faqFlightDelayQuestion: "Що станеться, якщо мій рейс затримається?",
  faqFlightDelayAnswer: "Немає проблем – час прибуття відстежується в режимі реального часу й автоматично коригується. Ваш водій знає про затримку та зачекає без додаткової плати.",
  faqCancelChangeQuestion: "Чи можу я скасувати або змінити своє бронювання?",
  faqCancelChangeAnswer: "Так, зміни та скасування безкоштовні аж до 24 годин до запланованого часу подачі.",
  faqChildSeatsQuestion: "Чи надаєте ви дитячі крісла та автомобілі, доступні для інвалідних візків?",
  faqChildSeatsAnswer: "Так, під час бронювання можна додати дитячі крісла різних груп, а наш клас вэнів у багатьох локаціях також доступний для інвалідних візків.",
  faqPaymentQuestion: "Які способи оплати приймаються?",
  faqPaymentAnswer: "Онлайн можна оплатити карткою, PayPal, Klarna, за рахунком або на виплат. Оплата водію на місці також можлива.",
  transferServiceDescription: "GoTransfer24 з'єднує вас із перевіреними водіями для приватних трансферів до аеропорту по всій Німеччині та Європі. Чи то ділова поїздка, сімейна відпустка чи міський тур – ми надійно та без зайвих зупинок довозимо вас до аеропорту або прямо до дверей. Фіксовані ціни, автоматичний моніторинг рейсів у разі затримок і бронювання менш ніж за хвилину роблять трансфер максимально простим.",
  routePriceCologneDusseldorf: "від 99 €",
  routePriceFrankfurtHeidelberg: "від 129 €",
  routePriceMunichAugsburg: "від 89 €",
  routePriceHamburgLuebeck: "від 79 €",
  routePriceBerlinPotsdam: "від 69 €",
  routePriceStuttgartUlm: "від 109 €",
  popularRoutes: "Популярні маршрути",
  allLocations: "Всі локації",
  chooseYour: "Оберіть свій",
  airport_: "аеропорт.",
  allLocationsOverview: "Огляд усіх локацій",
  locationsDescription: "GoTransfer24 з'єднує вас із перевіреними партнерами-водіями у 26 локаціях у 11 країнах. Кожне місто має власну сторінку з місцевими маршрутами, інформацією про термінали та питаннями, специфічними для цього аеропорту.",
  priceDisclaimer: "* Ціна, тривалість і відстань є приблизними та не є обов'язковою пропозицією.",
  somethingWentWrong: "Щось пішло не так. Спробуйте ще раз.",
  sustainability: "Сталий розвиток",
  everyRide: "Кожна поїздка",
  aTree: "одне дерево.",
  treePlantingDescription: "За кожне бронювання онлайн і через WhatsApp ми саджаємо дерево. Як екологічно свідома компанія, ми хочемо не лише сприяти сталій мобільності, а й активно робити внесок у захист довкілля. Дякуємо за вашу підтримку.",
  treesPlanted: "Посаджено дерев",
  compensated: "Компенсовано",
  howItWorks: "Як це працює",
  inFourSteps: "У 4 кроки",
  toBooking: "до бронювання.",
  ourStrengths: "Наші переваги",
  clearAdvantagesWith: "Явні переваги з",
  freeNonBindingService: "Безкоштовна послуга без зобов'язань",
  punctualPickupsGuaranteed: "Пунктуальна подача гарантована",
  verifiedDriverNetwork: "Перевірена мережа водіїв",
  upTo70PercentCheaperThanTaxis: "До 70% дешевше за таксі",
  topRatingsSatisfiedCustomers: "Найвищі оцінки від задоволених клієнтів",
  customerReviews: "Відгуки клієнтів",
  whatOurCustomers: "Що кажуть наші",
  say: "клієнти.",
  reviewMarco: "Дуже пунктуально, чисте авто та привітний водій. Буду бронювати ще.",
  reviewLena: "Легко забронювати і набагато дешевше за таксі. Ідеально для аеропорту!",
  reviewThomas: "Професійний сервіс від першого кліка до прибуття. Дуже рекомендую.",
  supportDescription: "Якщо у вас є питання, пропозиції чи коментарі, наша кваліфікована команда підтримки із задоволенням допоможе вам.",
  germany: "Німеччина",
  netherlands: "Нідерланди",
  belgium: "Бельгія",
  france: "Франція",
  luxembourg: "Люксембург",
  switzerland: "Швейцарія",
  austria: "Австрія",
  czechia: "Чехія",
  poland: "Польща",
  denmark: "Данія",
  turkey: "Туреччина",
  cologne: "Кельн",
  dusseldorf: "Дюссельдорф",
  frankfurt: "Франкфурт",
  munich: "Мюнхен",
  berlin: "Берлін",
  hamburg: "Гамбург",
  stuttgart: "Штутгарт",
  hannover: "Ганновер",
  amsterdam: "Амстердам",
  eindhoven: "Ейндговен",
  brussels: "Брюссель",
  charleroi: "Шарлеруа",
  paris: "Париж",
  luxembourgCity: "Люксембург",
  zurich: "Цюрих",
  geneva: "Женева",
  basel: "Базель",
  vienna: "Відень",
  prague: "Прага",
  warsaw: "Варшава",
  copenhagen: "Копенгаген",
  istanbul: "Стамбул",
  antalya: "Анталія",
  bodrum: "Бодрум",
  izmir: "Ізмір",
  ankara: "Анкара",
  priceCologneDusseldorf: "від 99 €",
  priceFrankfurtHeidelberg: "від 79 €",
  priceMunichAugsburg: "від 149 €",
  priceHamburgLuebeck: "від 149 €",
  allQuestions: "Всі питання",
  viewAnswers: "Переглянути відповіді",
  frequentlyAskedQuestions: "Часті запитання",
  questionsAbout: "Питання про",
  airportTransfer: "трансфер до аеропорту",
  travelKnowledge: "Знання про подорожі",
  guide: "Гід",
  our: "Наш",
  tipsInsightsNewsDescription: "Поради, огляди та новини про трансфери до аеропорту, подорожі та мобільність.",
  viewAllGuideArticles: "Переглянути всі статті гіда",
  haveAQuestion: "Маєте запитання?",
  travelTips: "Поради для подорожей",
  business: "Бізнес",
  family: "Родина",
  stressFreeAirportTransferTitle: "7 найкращих порад для трансферу до аеропорту без стресу",
  stressFreeAirportTransferDescription: "Як спланувати поїздку до аеропорту максимально комфортно – від правильного запасу часу до вибору потрібного класу авто.",
  businessTravelTitle: "Ділові поїздки: як спокійно дістатися до важливої зустрічі",
  businessTravelDescription: "Між рейсом і зустріччю часто залишається мало часу. Ми покажемо, як з правильним плануванням прибути вчасно та відпочилим.",
  familyVacationTitle: "Сімейна відпустка: безпечно до аеропорту з дітьми",
  familyVacationDescription: "Дитячі крісла, багаж і втомлені діти – ми даємо практичні поради, як зробити поїздку до аеропорту комфортною для всієї родини.",
  june12_2026: "12 червня 2026",
  may28_2026: "28 травня 2026",
  may15_2026: "15 травня 2026",
  readTime4Minutes: "4 хв читання",
  readTime3Minutes: "3 хв читання",
  readTime5Minutes: "5 хв читання",
  roundTripShort: "Туди й назад",
  editSearch: "Редагувати пошук",
  edit: "Редагувати",
  startNewSearch: "Почати новий пошук",
  cancel: "Скасувати",
  search: "Пошук",
  dateRequired: "Потрібна дата",
  timeRequired: "Потрібен час",
  returnDateRequired: "Потрібна дата зворотної поїздки",
  returnTimeRequired: "Потрібен час зворотної поїздки",
  vehicleCategory: "Категорія автомобіля",
  reset: "Скинути",
  categoryTaxi: "Таксі",
  categoryEconomy: "Економ",
  categoryBusiness: "Бізнес",
  categoryMinibus: "Мінібус",
  categoryMinibusWheelchair: "Мінібус для інвалідних візків",
  categoryGoGreen: "GoGreen",
  categoryFirstClass: "First Class",
  categoryKomfort: "Комфорт",
  categoryLuxury: "Люкс",
  filterTitle: "Фільтр",
  passengers: "Пасажири",
  vehiclesForAtLeast: "Автомобілі щонайменше на ≥",
  people: "осіб",
  luggage: "Багаж",
  luggagePieces: "Одиниці багажу",
  wheelchair: "Інвалідний візок",
  allVehicles: "Всі автомобілі",
  wheelchairSeats: "Місця для інвалідних візків",
  noRatingsYet: "Ще немає оцінок",
  orSimilar: "або подібний",
  upTo: "до",
  handLuggage: "Ручна поклажа",
  childSeatGroup1Name: "Дитяче крісло, група 1",
  childSeatGroup1Desc: "(Приблизно від 1 до 4 років), 9–18 кг",
  childSeatGroup23Name: "Дитяче крісло, група 2/3",
  childSeatGroup23Desc: "(Приблизно від 5 до 12 років), 18–38 кг",
  babySeatName: "Автокрісло для немовляти",
  babySeatDesc: "До 12 місяців. +1 кг – 9 кг",
  luggageHelpName: "Допомога з багажем",
  luggageHelpDesc: "Водій допомагає з багажем",
  meetGreetName: "Зустріч і привітання",
  meetGreetDesc: "Водій зустрічає вас із табличкою з іменем та допомагає з багажем.",
  privateRide: "Приватна поїздка",
  support247: "Підтримка 24/7",
  freeCancellation: "Безкоштовне скасування до 24 год перед поїздкою",
  provider: "Постачальник",
  bookNow: "Забронювати зараз",
  showLess: "Показати менше",
  moreOffers: "більше пропозицій",
  priceFrom: "Ціна від",
  book: "Забронювати",
  loadingOffers: "Завантаження пропозицій …",
  noOfferIdFound: "ID пропозиції не знайдено",
  errorLoadingOffers: "Помилка завантаження пропозицій",
  unknownError: "Невідома помилка",
  offersFound: "знайдено пропозицій",
  cheapest: "↑ Найдешевше",
  mostExpensive: "↓ Найдорожче",
  noVehiclesFound: "Автомобілів за обраними фільтрами не знайдено.",
  resetFilters: "Скинути фільтри",
  taxi_limousine: "Таксі седан",
  taxi_kombi: "Таксі універсал",
  taxi_van: "Таксі вэн",
  economy_limousine: "Економ седан",
  economy_kombi: "Економ універсал",
  economy_minivan: "Економ мінівен",
  economy_van: "Економ вэн",
  business_kombi: "Бізнес універсал",
  business_van: "Бізнес вэн",
  minibus: "Мінібус",
  business_limousine: "Бізнес седан",
  minibus_wheelchair: "Мінібус для інвалідних візків",
  gogreen: "GoGreen",
  firstclass: "First Class",
  komfort: "Комфорт",
  luxury: "Люкс",
  oclock: "год",
  vehicleSection: "Автомобіль",
  max: "Макс",
  included: "Включено",
  freeCancelShort: "Безкоштовне скасування",
  serviceProviderLabel: "Постачальник послуг",
  routeSection: "Маршрут",
  priceOverview: "Огляд цін",
  ride: "Поїздка",
  total: "Всього",
  loadingData: "Завантаження …",
  noSessionIdFound: "ID сесії не знайдено",
  dataLoadError: "Дані не вдалося завантажити.",
  less: "менше",
  more: "більше",
  free: "Безкоштовно",
  next: "Далі",
  saving: "Збереження …",
  errorSavingExtras: "Помилка збереження додаткових послуг.",
  extraServicesTitle: "Додаткові послуги",
  transferDetails: "Деталі трансферу",
  closeDetails: "Закрити деталі",
  showDetails: "Показати деталі",
  closeShort: "↓ Закрити",
  detailsShort: "↑ Деталі",
  totalPrice: "Загальна вартість",
  childSeatGroup1: "Дитяче крісло, група 1",
  childSeatGroup1Description: "(Приблизно від 1 до 4 років), 9–18 кг",
  childSeatGroup2_3: "Дитяче крісло, група 2/3",
  childSeatGroup2_3Description: "(Приблизно від 5 до 12 років), 18–38 кг",
  infantCarrier: "Автокрісло для немовляти",
  infantCarrierDescription: "До 12 місяців. +1 кг – 9 кг",
  waterSnack: "Вода та перекус",
  waterSnackDescription: "У автомобілі на вас чекають пляшка води та невеликий перекус.",
  petTransport: "Перевезення тварини",
  petTransportDescription: "Ваш улюбленець їде разом із вами. Будь ласка, візьміть переноску або повідець.",
  welcomeFlowers: "Квіти / вітальний набір",
  welcomeFlowersDescription: "Букет або вітальний набір для гостей в автомобілі – ідеально для готелів і весіль.",
  powerBank: "Повербанк / кабель для зарядки",
  powerBankDescription: "Кабель для зарядки та повербанк в автомобілі, щоб телефон приїхав зарядженим.",
  wifiHotspot: "Wi-Fi хотспот",
  wifiHotspotDescription: "Залишайтеся онлайн під час поїздки завдяки Wi-Fi в автомобілі.",
  priorityPickup: "Пріоритетна зустріч",
  priorityPickupDescription: "Водій чекає біля виходу та допомагає з багажним візком – найшвидший шлях до авто.",
  luggageAssistance: "Допомога з багажем",
  luggageAssistanceDescription: "Водій допомагає з багажем",
  meetAndGreet: "Зустріч і привітання",
  meetAndGreetDescription: "Водій зустрічає вас із табличкою з іменем та допомагає з багажем.",
  errorSavingData: "Помилка збереження даних.",
  fillRequiredFields: "Будь ласка, заповніть усі обов'язкові поля",
  fillAllRequiredFields: "Будь ласка, заповніть усі обов'язкові поля",
  requiredField: "Обов'язкове поле",
  invalidEmail: "Недійсна електронна адреса",
  pleaseSelect: "будь ласка, оберіть",
  title: "Звернення",
  salutation: "Звернення",
  lastName: "Прізвище",
  firstName: "Ім'я",
  mobileNumber: "Номер мобільного",
  emailAddress: "Електронна адреса",
  zipCode: "Поштовий індекс",
  city: "Місто",
  address: "Адреса",
  houseNumber: "№ будинку",
  flightNumber: "Номер рейсу",
  infoForDriver: "Інформація для водія",
  personalDataTitle: "Особисті дані",
  personalDataDesc: "Дані про вас",
  contactTitle: "Контакти",
  contactDesc: "Вкажіть тут свої контактні дані, щоб постачальник міг зв'язатися з вами за питаннями.",
  addressTitle: "Адреса",
  addressDesc: "Будь ласка, вкажіть свою повну адресу, щоб її можна було правильно вказати в рахунку.",
  outboundFlightTitle: "Дані рейсу туди",
  returnFlightTitle: "Дані зворотного рейсу",
  flightDataDesc: "Будь ласка, вкажіть повні дані рейсу, щоб ми могли оптимально спланувати ваш трансфер.",
  mr: "Пан",
  mrs: "Пані",
  diverse: "Інше",
  reviewAndPayTitle: "Перевірити дані та оплата",
  choosePaymentMethod: "Обрати спосіб оплати",
  comingSoon: "Скоро доступно",
  cashLabel: "Оплата готівкою",
  cashDesc: "Оплата безпосередньо водію – бронювання підтверджується миттєво",
  cardOnTripLabel: "Оплата карткою водію",
  cardOnTripDesc: "Оплата карткою на місці в день трансферу",
  stripeLabel: "Кредитна / дебетова картка",
  stripeDesc: "Visa, Mastercard, Amex, Apple Pay, Google Pay – миттєве підтвердження",
  customOfferLabel: "Зробити пропозицію",
  customOfferDesc: "Запропонуйте власну ціну – постачальник перевірить і підтвердить",
  yourOfferLabel: "Ваша пропозиція ціни",
  offerHint: "⏳ Має бути підтверджено постачальником – після цього ви отримаєте посилання на оплату електронною поштою.",
  offerInfoBanner: "Вашу пропозицію ціни буде передано постачальнику. Він повинен спочатку підтвердити вашу пропозицію. Після підтвердження ви отримаєте індивідуальне посилання на оплату електронною поштою.",
  invoiceLabel: "За рахунком",
  invoiceDesc: "Оплата після отримання рахунку",
  installmentLabel: "Розстрочка",
  installmentDesc: "Оплачуйте зручними частинами",
  couponTitle: "Промокод",
  couponPlaceholder: "Введіть код …",
  redeem: "Застосувати",
  couponInvalid: "Цей купон недійсний.",
  couponSuccess: "✓ Купон застосовано!",
  bookingOverviewTitle: "Огляд бронювання",
  reviewYourDataDesc: "Перевірте свої дані",
  contactShortDesc: "Ваші контактні дані",
  emailShort: "Ел. пошта",
  billingAddressDesc: "Адреса виставлення рахунку",
  zipShort: "Індекс",
  outboundFlightDesc: "Дані рейсу туди",
  returnFlightDesc: "Дані зворотного рейсу",
  checkoutLabel: "Оформлення",
  sumLabel: "Проміжна сума",
  regularPrice: "Звичайна ціна",
  vatNote: "* з урахуванням ПДВ",
  shareLink: "Поділитися посиланням",
  scanQrCode: "Сканувати QR-код",
  qrCodeAlt: "QR-код цієї сторінки",
  copyLink: "Скопіювати посилання",
  linkCopied: "✓ Посилання скопійовано!",
  agbTextBefore: "Я прочитав(-ла)",
  agbLinkLabel: "Загальні умови",
  agbTextAfter: "і приймаю їх. *",
  newsletterOptinLabel: "Так, я хочу отримувати розсилку та не пропускати пропозиції.",
  agbRequiredHint: "* Будь ласка, прийміть умови, щоб продовжити.",
  sendingOffer: "Надсилання пропозиції …",
  redirecting: "Перенаправлення …",
  submitOffer: "Надіслати пропозицію",
  payNow: "Оплатити зараз",
  bookingSubmitError: "Помилка під час надсилання бронювання.",
  stripeSecureNote: "Безпечна оплата – на базі Stripe",
  cashNote: "Оплата готівкою безпосередньо водію",
  offerPendingNote: "Постачальник підтверджує та надсилає посилання на оплату",
  completePaymentLabel: "Завершити оплату",
  footerCompanyDescription: "Ми розробили наш сервіс, щоб пропонувати вам надійні та якісні трансфери до аеропорту будь-де і будь-коли – без жодних проблем.",
  footerLinksTitle: "Посилання",
  aboutUs: "Про нас",
  bookTransfer: "Забронювати трансфер",
  footerServiceTitle: "Сервіс",
  vehicleFleet: "Автопарк",
  faq: "Часті питання",
  footerLegalTitle: "Правова інформація",
  imprint: "Вихідні дані",
  privacyPolicy: "Політика конфіденційності",
  termsAndConditions: "Умови надання послуг",
  newsletterTitle: "Розсилка",
  newsletterDescription: "Актуальні новини та оновлення прямо на вашу пошту.",
  emailPlaceholder: "Ваша електронна адреса",
  sending: "Надсилання…",
  subscribe: "Підписатися",
  newsletterEmailRequired: "Будь ласка, введіть електронну адресу.",
  newsletterEmailInvalid: "Будь ласка, введіть дійсну електронну адресу.",
  newsletterSuccess: "Дякуємо! Ви успішно підписалися.",
  newsletterError: "Підписка не вдалася. Спробуйте ще раз.",
  allRightsReserved: "Всі права захищено.",
  affiliateProgram: "Партнерська програма",
  affiliateHeroTitle: "Приєднуйтесь до",
  affiliateHeroAccent: "GoTransfer24.",
  affiliateHeroSub: "Рекомендуйте нас у соцмережах, на своєму сайті чи через свою компанію та заробляйте на кожній успішно залученій поїздці.",
  becomeAffiliateCta: "Стати партнером",
  whyPartnerWithUs: "Чому саме ми?",
  affiliateBenefitsTitleLine1: "Що ви отримуєте",
  affiliateBenefitsTitleLine2: "як партнер.",
  affiliateBenefit1: "Індивідуальна комісія за кожне залучене бронювання",
  affiliateBenefit2: "Власне трекінгове посилання для легкого відстеження",
  affiliateBenefit3: "Щомісячна виплата, повна прозорість",
  affiliateBenefit4: "Без мінімального обороту, без прихованих витрат",
  affiliateCommissionTitle: "Як розраховується комісія?",
  affiliateCommissionExplanationText: "Комісія розраховується індивідуально та залежить від охоплення, цільової аудиторії та очікуваного обсягу залучень. Залежно від профілю партнера вона зазвичай становить від 5% до 15% за кожне успішно залучене бронювання. Після подання заявки ви отримаєте персональну пропозицію з вашою конкретною ставкою.",
  affiliateCommissionDisclaimer: "Комісія розраховується індивідуально та повідомляється після розгляду вашої заявки.",
  affiliateStepsTitle: "3 кроки до партнерства",
  affiliateStep1Title: "Подайте заявку",
  affiliateStep1Desc: "Заповніть форму та вкажіть своє охоплення.",
  affiliateStep2Title: "Розгляд і пропозиція",
  affiliateStep2Desc: "Ми розглянемо ваш профіль і надішлемо вашу індивідуальну ставку.",
  affiliateStep3Title: "Рекомендуйте та заробляйте",
  affiliateStep3Desc: "Поділіться посиланням і отримуйте комісію з кожного бронювання.",
  affiliateFinalCtaTitle: "Готові рости разом із нами?",
  affiliateMetaTitle: "Партнерська програма",
  affiliateMetaDescription: "Станьте партнером GoTransfer24 і заробляйте індивідуально розраховану комісію з кожного залученого бронювання трансферу до аеропорту.",
  becomeAffiliateTitle: "Стати партнером",
  becomeAffiliateIntro: "Заповніть форму – ми зв'яжемося з вами з індивідуальною пропозицією.",
  firstNameRequiredError: "Будь ласка, введіть ім'я",
  lastNameRequiredError: "Будь ласка, введіть прізвище",
  emailRequiredError: "Будь ласка, введіть електронну адресу",
  emailInvalidError: "Будь ласка, введіть дійсну електронну адресу",
  atLeastOneOfTheFollowing: "Заповніть щонайменше одне з наступних полів:",
  atLeastOneSocialRequiredError: "Будь ласка, вкажіть принаймні один акаунт у соцмережах або компанію",
  companyOptional: "Компанія (необов'язково)",
  companyNamePlaceholder: "Назва компанії",
  submitApplication: "Надіслати заявку",
  affiliateApplicationReceivedTitle: "Заявку отримано!",
  affiliateApplicationReceivedText: "Дякуємо за ваш інтерес. Ми розглянемо ваші дані та зв'яжемося з вами з індивідуальною пропозицією комісії.",
  close: "Закрити",
  successTitleOffer: "Пропозицію отримано!",
  successTitleConfirmed: "Бронювання підтверджено!",
  emailFallback: "Ваша електронна адреса",
  thankYouLabel: "Дякуємо",
  offerSubtitlePart1: "! Вашу пропозицію ціни",
  offerSubtitlePart2: "передано постачальнику. Після розгляду ви отримаєте індивідуальне посилання на оплату на",
  cashSubtitlePart1: "! Ваше бронювання підтверджено. Будь ласка, оплатіть суму безпосередньо водію. Підтвердження буде надіслано на",
  defaultSubtitlePart1: "! Вашу оплату успішно опрацьовано. Підтвердження бронювання буде надіслано на",
  bookingNumberLabel: "Номер бронювання",
  paymentTypeLabel: "Тип оплати",
  creditCardLabel: "Кредитна картка",
  offerPaymentTypeLabel: "Пропозиція",
  statusLabel: "Статус",
  statusPendingProviderCheck: "Очікується – постачальник перевіряє",
  statusConfirmed: "Підтверджено",
  redirectingToOverviewPart1: "Вас буде перенаправлено до огляду бронювань через",
  secondsLabel: "секунду",
  redirectingToOverviewPart3: "…",
  redirectFailedText: "Автоматичне перенаправлення не вдалося.",
  goToBookingOverview: "До огляду бронювань →",
  backToHomeLabel: "На головну",
  cookieSettings: "Налаштування файлів cookie",
  logout: "Вийти",
  language: "Мова",
  ourtransfers: "Мої поїздки",
  profiledescription: "Всі призначені вам бронювання трансферу",
  rows: "Записи",
  filtered: "відфільтровано",
  searchPlaceholder: "Пошук",
  pagingOf: "з",
  searchLabel: "Пошук",
  resetFilter: "скинути",
  selectedCount: "обрано",
  clearSelection: "очистити",
  menuOpen: "Відкрити меню",
  menuClose: "Закрити меню",
  flightScheduled: "За розкладом",
  flightActive: "У польоті",
  flightLanded: "Приземлився",
  flightCancelled: "Скасовано",
  flightDiverted: "Перенаправлено",
  flightIncident: "Інцидент",
  flightRedirected: "Перенаправлено",
  flightPrefix: "Рейс",
  flightLoading: "Завантаження даних про рейс …",
  flightNotFound: "Дані про рейс не знайдено для",
  flightCheckNote: "Будь ласка, перевірте номер рейсу в примітці.",
  flightDeparture: "Виліт",
  flightArrival: "Приліт",
  flightPlanned: "Заплановано",
  flightDelay: "Затримка",
  flightDelayDep: "хв виліт",
  flightDelayArr: "хв приліт",
  flightBaggage: "Видача багажу",
  flightBaggageBand: "Стрічка",
  flightAirline: "Авіакомпанія",
  chatWithCustomer: "Чат із клієнтом",
  chatBooking: "Бронювання",
  chatLoading: "Завантаження повідомлень …",
  chatEmpty: "Повідомлень ще немає. Напишіть клієнту повідомлення.",
  chatInputPlaceholder: "Написати повідомлення …",
  chatDisabled: "Чат вимкнено для минулих/майбутніх поїздок",
  chatOnlyToday: "Чат доступний лише в день поїздки",
  chatClose: "Закрити чат",
  chatOpenLabel: "Відкрити чат",
  chatButtonLabel: "Чат",
  chatLoadError: "Помилка завантаження повідомлень",
  chatSendFail: "Не вдалося надіслати повідомлення",
  chatSendError: "Помилка надсилання повідомлення",
  salutationMr: "Пан",
  salutationMrs: "Пані",
  tripReturn: "Туди й назад",
  tripOneway: "В один бік",
  noTripsAvailable: "Немає доступних поїздок.",
  noTripsSearch: "Немає результатів для поточного пошуку",
  noTrips: "Немає доступних поїздок",
  pickupTag: "Подача",
  destinationTag: "Призначення",
  paymentLabel: "Оплата",
  passengersLabel: "Пасажири",
  customerLabel: "Клієнт",
  phoneLabel: "Номер телефону",
  extrasLabel: "Додаткові послуги",
  noteLabel: "Примітка",
  flightInfoLabel: "Інформація про рейс",
  yourSharePrefix: "Ваша частка (в один бік)",
  cancelBtn: "Скасувати",
  counterOfferBtn: "Контрпропозиція",
  waitingCustomerResponse: "Очікування відповіді клієнта",
  newBadge: "Нове",
  enrouteBtn: "В дорозі",
  onboardBtn: "Забрано",
  noshowBtn: "Не з'явився",
  completeBtn: "Завершити",
  cancelledBadge: "Скасовано",
  completedBadge: "Завершено",
  noshowDoneBadge: "Не з'явився",
  complainedBadge: "Скарга",
  cancelTripTitle: "Скасувати поїздку?",
  cancelBookingPrefix: "Бронювання",
  cancelIrreversible: "Цю дію неможливо скасувати.",
  cancelNotifyText: "Поїздку буде скасовано, а клієнта повідомлено.",
  fromLabel: "Звідки",
  toLabel: "Куди",
  dateLabel: "Дата",
  abortBtn: "Скасувати",
  confirmCancelBtn: "Так, скасувати зараз",
  tripCancelledToast: "скасовано",
  cancelErrorToast: "Помилка скасування",
  statusEnrouteLabel: "Почати рух",
  statusEnrouteDesc: "Ви зараз розпочинаєте поїздку до клієнта.",
  statusOnboardLabel: "Пасажира забрано",
  statusOnboardDesc: "Ви підтверджуєте, що забрали пасажира.",
  statusCompletedLabel: "Завершити поїздку",
  statusCompletedDesc: "Ви позначаєте цю поїздку як завершену.",
  confirmBtn: "Підтвердити",
  statusUpdateError: "Помилка оновлення",
  statusEnrouteToast: "Рух розпочато",
  statusOnboardToast: "Пасажира забрано",
  statusCompletedToast: "Поїздку завершено",
  counterOfferTitle: "Зробити контрпропозицію",
  originalPriceLabel: "Початкова ціна",
  customerOfferLabel: "Пропозиція клієнта",
  yourCounterOfferLabel: "Ваша контрпропозиція",
  counterOfferInvalid: "Будь ласка, введіть дійсну суму.",
  counterOfferSaveError: "Помилка збереження. Спробуйте ще раз.",
  counterOfferNotifyInfo: "Клієнт отримає сповіщення після збереження.",
  counterOfferSaving: "Збереження …",
  counterOfferSendBtn: "Надіслати контрпропозицію",
  counterOfferSavedToast: "Контрпропозицію для",
  counterOfferSavedToastSuffix: "збережено",
  vehicleDialogTitle: "Обрати автомобіль",
  vehicleLoading: "Завантаження автомобілів …",
  vehicleLoadError: "Не вдалося завантажити автомобілі.",
  vehicleLoadErrorGeneric: "Помилка завантаження автомобілів.",
  vehicleNoneAvailable: "Немає доступних автомобілів.",
  vehicleStarting: "Запуск …",
  vehicleStartBtn: "Почати рух",
  vehiclePleaseChoose: "Будь ласка, оберіть автомобіль",
  vehicleSaveError: "Помилка збереження.",
  vehicleStartError: "Помилка початку руху.",
  vehicleStartedToast: "Рух розпочато",
  vehicleFallbackName: "Автомобіль",
  noshowDialogTitle: "Повідомити про неявку",
  noshowInstructions: "Будь ласка, зробіть фото місця подачі, на якому чітко видно ваш автомобіль. Місцезнаходження буде зафіксовано автоматично.",
  noshowMaxSizeSuffix: "Макс.",
  currentLocationLabel: "Поточне місцезнаходження",
  locationLoading: "Визначення місцезнаходження …",
  locationReload: "Перезавантажити",
  locationRetry: "Спробувати ще раз",
  locationUnavailable: "Місцезнаходження недоступне",
  geoNotSupported: "Геолокація не підтримується цим пристроєм.",
  geoDenied: "Не вдалося визначити місцезнаходження. Будь ласка, дозвольте доступ.",
  photoOfPickupLabel: "Фото місця подачі",
  photoTakeLabel: "Зробити фото",
  photoHint: "Відкрити камеру · Автомобіль має бути видимим",
  photoChange: "Змінити",
  noshowNoteLabel: "Примітка",
  noshowNoteOptional: "(необов'язково)",
  noshowNotePlaceholder: "напр., дзвінок недоступний, немає відповіді на дзвінок …",
  noshowMissingPhoto: "Будь ласка, зробіть фото місця подачі.",
  noshowLocationPending: "Місцезнаходження ще визначається. Будь ласка, зачекайте.",
  noshowPhotoTooLargePrefix: "Фото занадто велике",
  noshowPhotoTooLargeMax: "Максимум",
  noshowPhotoTooLargeHint: "Будь ласка, зробіть менше фото або зменшіть якість камери.",
  noshowPhotoTooLargeHintShort: "Будь ласка, зробіть менше фото.",
  noshowGenericSaveError: "Помилка збереження. Спробуйте ще раз.",
  noshowSubmitError: "Помилка надсилання. Спробуйте ще раз.",
  noshowSubmitting: "Надсилання …",
  noshowConfirmBtn: "Підтвердити неявку",
  noshowReportedToast: "Неявку повідомлено для",
  pickupLabel: "Місце подачі",
  current: "Поточні",
  trips: "Поїздки",
  myData: "Мої дані",
  documents: "Документи",
  other: "Інше",
  vehicle_class: "Мої автомобілі",
  company: "Моя компанія",
  cities: "Міста",
  wallet: "Гаманець",
  receipts: "Квитанції",
  terms: "Умови надання послуг",
  privacy: "Політика конфіденційності",
  new: "Нове",
  overview: "Огляд",
  income: "Дохід",
  expenses: "Витрати",
  welcomeBack: "З поверненням",
  dashboardErrorTitle: "Щось пішло не так",
  dashboardErrorText: "Не вдалося завантажити дані.",
  noWidgetsTitle: "Віджети не налаштовано",
  noWidgetsText: "Наразі немає доступних оглядових плиток.",
  completed: "Завершено",
  upcoming: "Майбутні",
  cancelled: "Скасовано",
  noShow: "Не з'явився",
  complained: "Скарга",
  tomorrow: "Завтра",
  thisWeek: "Цього тижня",
  count: "Кількість",
  ofWhichNoShow: "З них неявка",
  ofWhichComplained: "З них скарги",
  transfer_total: "Всього",
  transfer_done: "Завершено",
  transfer_open: "Майбутні",
  transfer_week: "Цього тижня",
  transfer_storno_reklamiert: "З них скарги",

  newTrips: "Нові поїздки",
  notransferdatafound: "Немає доступних поїздок.",
  noResultsForFilters: "Немає результатів для поточних фільтрів",
  returnTripOn: "Зворотна поїздка",

  generateInvoice: "Створити рахунок",
  details: "Деталі",
  accept: "Прийняти",
  changeDriver: "Змінити водія",
  assignDriver: "Призначити водія",
  cancelList: "Скасувати",

  counterOffer: "Контрпропозиція",
  acceptOffer: "Прийняти пропозицію",
  waitingForCustomerResponse: "Очікування відповіді клієнта",
  waitingForCustomerPayment: "Очікування оплати клієнта",
  accepted: "Прийнято",

  pleaseAssignDriver: "Будь ласка, призначте водія",
  driverOnTheWay: "Водій в дорозі",

  customerOnBoard: "Клієнт в авто",

  acceptOfferQuestion: "Прийняти пропозицію?",
  bookingPrefix: "Бронювання",

  confirmCustomerOffer: "Підтвердити пропозицію клієнта",
  customerOfferPaymentInfo: "Клієнт отримає сповіщення електронною поштою та буде перенаправлений до оплати. Після оплати бронювання буде підтверджено автоматично.",

  offerPrice: "Ціна пропозиції",

  yesAcceptOffer: "Так, прийняти пропозицію",

  selectDriver: "Обрати водія",
  loadingDrivers: "Завантаження водіїв …",
  noDriversAvailable: "Немає доступних водіїв.",

  confirmTrip: "Підтвердити поїздку",
  pleaseSelectDriver: "Будь ласка, оберіть водія",

  cancelTripQuestion: "Скасувати поїздку?",
  cancelNotifyCustomer: "Поїздку буде скасовано, а клієнта повідомлено.",

  from: "Звідки",
  to: "Куди",

  confirmCancel: "Так, скасувати зараз",

  create: "Створити",

  makeCounterOffer: "Зробити контрпропозицію",
  originalPrice: "Початкова ціна",
  customerOffer: "Пропозиція клієнта",
  yourCounterOffer: "Ваша контрпропозиція",
  counterOfferNotify: "Клієнт отримає сповіщення після збереження.",
  sendCounterOffer: "Надіслати контрпропозицію",
  // StepDialog (Новий запис)
  newRecordTitle: "Створити новий запис",
  stepLabel: "Крок",
  ofLabel: "з",
  enterValuePlaceholder: "введіть...",
  yes: "Так",
  no: "Ні",

  // MatchDialog
  selectMatch: "Зробити вибір",

  // ConfirmDialog
  affectedRecords: "Зачеплені записи:",

  // FilterDialog
  applyFilterTitle: "Застосувати фільтр",
  applyFilterSubtitle: "Фільтрувати записи за критеріями",
  active: "Активний",
  inactive: "Неактивний",
  noFilterableFields: "Немає полів для фільтрації",
  applyFilterButton: "✓ Застосувати фільтр",

  // AdminEditDialog
  editRecordTitle: "Редагувати запис",
  bookingLabel: "Бронювання",
  noEditableFields: "Немає налаштованих полів для редагування",
  savingEllipsis: "Збереження …",
  saveButton: "✓ Зберегти",
  adminEditTooltip: "Редагувати запис (адмін)",

  // Footer / Paging
  filteredLabel: "(відфільтровано)",
  recordsLabel: "Записи",
  filterLabel: "Фільтр:",
  selectedLabel: "обрано",
  clearLabel: "очистити",

  // Trip-Type Fallbacks
  tripTypeReturn: "Туди й назад",
  tripTypeOneway: "В один бік",

  // Formatting
  driverFallbackPrefix: "Водій #",

  // Toasts
  toastOfferAccepted: "Пропозицію для #{id} прийнято – клієнта буде повідомлено",
  toastInvoiceCreated: "Рахунок для #{id} створено",
  toastDriverChanged: "Водія змінено",
  toastDriverConfirmed: "підтверджено",
  toastTripUpdated: "Поїздку #{id} оновлено ({label})",
  toastTripCancelled: "Поїздку #{id} скасовано",
  toastCounterOfferSaved: "Контрпропозицію для #{id} збережено",
  toastRecordUpdated: "Запис #{id} оновлено",

  // Error Messages
  errorAcceptOffer: "Помилка прийняття пропозиції",
  errorCreateInvoice: "Помилка створення рахунку",
  errorSaveTrip: "Помилка збереження поїздки.",
  errorChangeDriver: "Помилка зміни водія.",
  errorConfirmTrip: "Помилка підтвердження поїздки.",
  errorCancelTrip: "Помилка скасування",
  errorInvalidAmount: "Будь ласка, введіть дійсну суму.",
  errorSaveRetry: "Помилка збереження. Спробуйте ще раз.",
  errorLoadDriversFailed: "Не вдалося завантажити водіїв.",
  errorLoadDrivers: "Помилка завантаження водіїв.",
  errorSaveDefault: "Помилка збереження",
  discount: "Знижка",
  couponAvailableNote: "Отримайте свій купон на знижку зараз!",
  copied: "Скопійовано!",
  clickToCopy: "Натисніть, щоб скопіювати",
  appDownloadBannerText: "Застосунок GoTransfer24",
  appDownloadBannerCta: "Завантажити",
  planned: "Заплановано",
  aktive_stat: "Активний",
  done: "Завершено",
  en_route: "Водій в дорозі",
  onboard: "Клієнт в авто",
  card: "Оплата карткою",
  cash: "Оплата готівкою",
  cardOnTrip: "Оплата карткою водію",
  cardontrip: "Оплата карткою водію",
  thisweek: "Цього тижня",
  unpaid: "Очікується оплата",
  paid: "Оплачено",
  paypalLabel: "PayPal",
  paypalDesc: "Безпечна оплата через ваш обліковий запис PayPal",
  paypalSecureNote: "Вас буде безпечно перенаправлено до PayPal",
  redirectingPaypal: "Перенаправлення до PayPal …",
  paypalCancelledNote: "Оплату через PayPal скасовано.",
  paypalFailedNote: "Оплату через PayPal не вдалося завершити.",
  paypal: "paypal",
  actual: "Поточні",
  transfers: "Поїздки",
  mydata: "Мої дані",
  others: "Інше",
  vehicleclass: "Мої автомобілі",
  impressum: "Вихідні дані",
  agb: "Умови надання послуг",
  datenschutz: "Політика конфіденційності",
  booking: "Бронювання",
  transferTripLabel: "Трансферна поїздка",
  outboundReturnTrip: "Туди й назад",
  onewayTrip: "В один бік",
  departureLabel: "Відправлення",
  distanceLabel: "Відстань",
  returnTripSection: "Зворотна поїздка",
  customerSection: "Клієнт",
  baggageLabel: "Багаж",
  emergencyContactLabel: "Контакт для екстрених випадків",
  paymentSection: "Оплата",
  basePriceLabel: "Базова ціна",
  offerPriceLabel: "Ціна пропозиції",
  counterOfferLabel: "Контрпропозиція",
  categoryLabel: "Категорія",
  paymentMethodLabel: "Спосіб оплати",
  pricePerKmLabel: "Ціна/км",
  receiptLabel: "Квитанція",
  createdLabel: "Створено",
  notCreatedYetLabel: "Ще не створено",
  noCounterOfferYet: "Контрпропозицій ще не подано",
  priceAccepted: "Ціну прийнято",
  noShowReportSection: "Звіт про неявку",
  reportedAtLabel: "Повідомлено о",
  accuracyLabel: "Точність",
  locationLabel: "Місцезнаходження",
  openInGoogleMaps: "Відкрити в Google Maps",
  driverNoteLabel: "Примітка водія",
  driverNoticeLabel: "Повідомлення водія",
  driverPhotoLabel: "Фото від водія",
  noShowPhotoAlt: "Фото-підтвердження неявки",
  extrasSection: "Додаткові послуги",
  totalExtrasLabel: "Всього додаткових послуг",
  notesSection: "Примітки",
  customerNoteLabel: "Примітка клієнта",
  shortNoteLabel: "Коротка примітка",
  internalNoteLabel: "Внутрішня примітка",
  ratingSection: "Оцінка",
  bookingDetailsSection: "Деталі бронювання",
  createdAtLabel: "Дата створення",
  updatedAtLabel: "Оновлено",
  bookingSourceLabel: "Джерело бронювання",
  tripTypeLabel: "Тип поїздки",
  externalIdLabel: "Зовнішній ID",
  canceledAtLabel: "Скасовано о",
  cancelReasonLabel: "Причина скасування:",
  paymentPendingLabel: "Очікується оплата",
  paidLabel: "Оплачено",
  paymentFailedLabel: "Не вдалося",
  sourceWebsite: "Веб-сайт",
  sourceManual: "Вручну",
  sourceApi: "API",
  // Українська (uk.js)
  pleaseSelectImageFile: "Будь ласка, оберіть файл зображення.",
  fileTooLargeError: "Файл занадто великий (макс. 10 МБ).",
  driverCreatedToast: "Водія створено",
  driverCreateErrorFallback: "Помилка створення водія",
  deleteDriverTitle: "Видалити водія",
  deleteDriverConfirmPrefix: "Ви дійсно хочете видалити",
  deleteDriverConfirmSuffix: "? Цю дію неможливо скасувати.",
  driverDeletedToast: "Водія видалено",
  deleteErrorToast: "Помилка видалення",
  wasDeactivated: "деактивовано",
  wasActivated: "активовано",
  statusUpdateErrorToast: "Помилка оновлення статусу",
  licenseExpired: "Термін дії закінчився",
  licenseExpiresIn: "Закінчується через",
  daysAbbrev: "дн.",
  licenseValidUntil: "Дійсно до",
  activeLabel: "Активний",
  inactiveLabel: "Неактивний",
  detailsButton: "Деталі",
  deactivateButton: "Деактивувати",
  activateButton: "Активувати",
  deleteButton: "Видалити",
  createDriverTitle: "Додати нового водія",
  yesLabel: "Так",
  noLabel: "Ні",
  enterPlaceholderSuffix: "введіть…",
  enterPlaceholderSuffixNoDots: "введіть...",
  profilePhotoLabel: "Фото профілю",
  optionalLabel: "необов'язково",
  previewAlt: "Попередній перегляд",
  changePhotoLabel: "Змінити фото",
  uploadPhotoLabel: "Завантажити фото",
  removePhotoLabel: "Видалити фото",
  photoOptionalHint: "Не є обов'язковим – фото можна додати пізніше в профілі.",
  cancelButton: "Скасувати",
  creatingLabel: "Створення…",
  createButton: "Створити",
  enabledLabel: "Увімкнено",
  disabledLabel: "Вимкнено",
  filterDriversDesc: "Фільтрувати водіїв за критеріями",
  resetButton: "Скинути",
  filterButton: "Фільтр",
  newDriverButton: "Новий водій",
  ofLabelLower: "з",
  driversLabel: "Водії",
  searchColonLabel: "Пошук:",
  resetLowerButton: "скинути",
  filterColonLabel: "Фільтр:",
  clearLowerButton: "очистити",
  loadingAriaLabel: "Завантаження…",
  // Українська (uk.js)
  driverSavedToast: "Водія збережено",
  saveErrorToast: "Помилка збереження",
  imageProcessingError: "Помилка обробки зображення.",
  savingLabel: "Збереження…",
  photoCardTitle: "Фото",
  photoSizeHint: "JPG/PNG, макс. 10 МБ · буде зменшено до 300×600 px",
  dataCardTitle: "Дані",
  // Українська (uk.js)
  licensePlateHint: "Формат: 1–3 літери, 1–2 літери, 1–4 цифри – напр. M AB 1234",
  pricesLoadError: "Не вдалося завантажити ціни.",
  vehiclesLoadError: "Не вдалося завантажити автомобілі.",
  pleaseSelectBrandError: "Будь ласка, оберіть або введіть марку",
  pleaseSelectModelError: "Будь ласка, оберіть або введіть модель",
  pleaseSelectColorError: "Будь ласка, оберіть або введіть колір",
  pleaseEnterLicensePlateError: "Будь ласка, введіть номерний знак",
  invalidFormatPrefix: "Недійсний формат –",
  vehicleAddedToast: "Автомобіль додано",
  vehicleAddErrorToast: "Помилка додавання автомобіля",
  vehicleDeletedToast: "Автомобіль видалено",
  vehicleDeleteErrorToast: "Помилка видалення автомобіля",
  vehicleActivatedToast: "Автомобіль активовано",
  vehicleDeactivatedToast: "Автомобіль деактивовано",
  statusChangeErrorToast: "Помилка зміни статусу",
  pleaseSFillValidPricePrefix: "Будь ласка, заповніть",
  pleaseSFillValidPriceSuffix: "дійсною ціною",
  pricesSavedToast: "Ціни збережено",
  pricesSaveErrorToast: "Помилка збереження цін",
  vehicleCategoriesTitle: "Категорії автомобілів",
  vehicleCategoriesDesc: "Керуйте ступеневими тарифами та автомобілями безпосередньо за категоріями.",
  vehiclesInThisClass: "Автомобілі в цьому класі",
  pricesSectionLabel: "Ціни",
  tiersLabel: "Ступені",
  pricePerKmShort: "€ / км",
  minPriceLabel: "Мінімальна ціна",
  savePricesButton: "Зберегти ціни",
  vehiclesSectionLabel: "Автомобілі",
  loadingVehiclesLabel: "Завантаження автомобілів…",
  noVehiclesInClassLabel: "У цьому класі немає автомобілів",
  brandLabel: "Марка",
  modelLabel: "Модель",
  colorLabel: "Колір",
  licensePlateLabel: "Номерний знак",
  addVehicleTitle: "Додати автомобіль",
  selectBrandOption: "Оберіть марку…",
  otherOption: "Інше…",
  enterBrandPlaceholder: "Введіть марку",
  selectModelOption: "Оберіть модель…",
  selectBrandFirstOption: "Спочатку оберіть марку",
  enterModelPlaceholder: "Введіть модель",
  selectColorOption: "Оберіть колір…",
  enterColorPlaceholder: "Введіть колір",
  licensePlateExamplePlaceholder: "напр. M AB 1234",
  addVehicleButton: "Додати автомобіль",
  deleteVehicleModalTitle: "Видалити автомобіль?",
  thisVehicleLabel: "Цей автомобіль",
  willBeRemovedFromCategoryPrefix: "буде остаточно видалено з категорії",
  willBeRemovedFromCategorySuffix: ".",
  deletingLabel: "Видалення…",
  // Українська (uk.js)
  fileTooLargeMaxAlert: "Файл занадто великий. Максимум: 10 МБ",
  addressInputPlaceholder: "Введіть адресу та оберіть зі списку...",
  previewSuffix: "Попередній перегляд",
  uploadSuffix: "завантажити",
  removeButton: "Видалити",
  photoUploadRecommendationHint: "Рекомендовано: JPG/PNG, макс. 10 МБ, автоматично зменшується до 300x600px",
  addressRequiredFieldError: "Обов'язкове поле – будь ласка, оберіть адресу зі списку",
  noFieldGroupsDefined: "Групи полів не визначено",
  fillAllRequiredAddressFieldsError: "Будь ласка, заповніть усі обов'язкові поля – для полів адреси оберіть варіант зі списку.",
  readonlyLabel: "лише для читання",
  // Українська (uk.js)
  selectAtLeastOneRecordError: "Будь ласка, оберіть щонайменше один запис.",
  selectOnlyOneRecordToEditError: "Будь ласка, оберіть лише один запис для редагування.",
  noRecordsSelectedError: "Записи не обрано.",
  actionExecutedSuccessSuffix: "успішно виконано",
  noDataAvailableLabel: "Дані відсутні.",
  noRecordsAvailableLabel: "Записи відсутні",
  createNewRecordTitle: "Створити новий запис",
  makeSelectionTitle: "Зробити вибір",
  affectedRecordsLabel: "Зачеплені записи:",
  idsLabel: "ID",
  filterRecordsDesc: "Фільтрувати записи за критеріями",
  deselectAllLabel: "Скасувати весь вибір",
  selectAllLabel: "Обрати все",
  clearSelectionLabel: "Очистити вибір",
  sortedByLabel: "Відсортовано",
  filtersActiveLabel: "Активні фільтри",
  // Українська (uk.js)
  addButtonLabel: "Додати",
  // Українська (uk.js)
  periodAllLabel: "Всі",
  periodTodayLabel: "Сьогодні",
  periodWeekLabel: "Тиждень",
  periodMonthLabel: "Місяць",
  periodYearLabel: "Рік",
  transferLabel: "Банківський переказ",
  cashShortLabel: "Готівка",
  cardShortLabel: "Картка",
  canceledLabel: "Скасовано",
  balanceLoadError: "Не вдалося завантажити баланс.",
  noWalletDataFound: "Дані гаманця не знайдено.",
  partnerAccountLabel: "Партнерський рахунок",
  walletTitle: "Гаманець",
  currentBalanceLabel: "Поточний баланс",
  noPayableBalanceTitle: "Немає коштів для виплати",
  payoutButton: "Вивести",
  transactionsLabel: "Транзакції",
  searchBookingNumberPlaceholder: "Пошук за номером бронювання",
  noResultsForPrefix: "Немає результатів для",
  noTransactionsInPeriod: "Немає транзакцій за цей період.",
  closeAriaLabel: "Закрити",
  payoutRequestedTitle: "Запит на виплату надіслано",
  willBeTransferredSoonText: "незабаром буде переказано на вказаний рахунок.",
  closeButton: "Закрити",
  confirmPayoutTitle: "Підтвердити виплату",
  amountTransferredToAccountText: "Сума буде переказана на такий рахунок:",
  accountHolderLabel: "Власник рахунку",
  ibanLabel: "IBAN",
  bankLabel: "Банк",
  payoutAmountLabel: "Сума виплати",
  payoutTriggerErrorText: "Не вдалося ініціювати виплату. Спробуйте ще раз.",
  requestingPayoutLabel: "Запит…",
  payoutNowButton: "Вивести зараз",
  //LAST UPDATE 20082026
  passengerCountTitle: "Кількість пасажирів",
  // Ukrainisch
paymentCreditCardTitle: "Кредитна картка",
paymentCreditCardDescription: "Безпечна онлайн-оплата одразу під час бронювання.",
paymentPaypalTitle: "PayPal",
paymentPaypalDescription: "Зручна оплата через ваш рахунок PayPal – можлива відстрочена оплата або оплата частинами.",
paymentCashTitle: "Готівкою",
paymentCashDescription: "Сплатіть фіксовану ціну готівкою безпосередньо водію.",
paymentCardOnTripTitle: "Картка у водія",
paymentCardOnTripDescription: "Безконтактна оплата карткою прямо в автомобілі.",
paymentCustomOfferTitle: "Власна пропозиція ціни",
paymentCustomOfferDescription: "Запропонуйте свою ціну, наш партнер підтвердить її.",
paymentTagInstant: "Миттєве підтвердження",
paymentTagSSL: "SSL-шифрування",
paymentTagInstallments: "Оплата частинами",
paymentTagPayLater: "Оплата пізніше",
paymentTagNoPrepay: "Без передоплати",
paymentTagContactless: "Безконтактно",
paymentTagNegotiable: "Можна домовитись",
payHowItSuitsYou: "Платіть так,",
payHowItSuitsYouAccent: "як зручно вам.",
// Ukrainisch
roundTripSavingsNotice: "Ви заощаджуєте {percent}% при бронюванні поїздки в обидва боки.",
removeReturnTrip: "Видалити зворотну поїздку",
selectDate: "Виберіть дату",
clockSuffix: "",
back: "Назад",
date: "Дата",
time: "Час",
apply: "Застосувати",
pleaseChoose: "Будь ласка, оберіть",
cityAirport: "Місто / Аеропорт",
addReturnTrip: "Додати зворотну поїздку",
closeForm: "Закрити форму",
transferMode: "Трансфер",
flightsMode: "Авіаквитки",
slide: "Слайд",
hotline: "Гаряча лінія",
email: "Електронна пошта",
enterStartAddressError: "Будь ласка, введіть адресу відправлення",
selectAddressFromListError: "Будь ласка, оберіть адресу зі списку",
enterDestinationAddressError: "Будь ласка, введіть адресу призначення",
dateRequiredError: "Дата обов'язкова",
timeRequiredError: "Час обов'язковий",
departureTimeMinOneHourError: "Час відправлення повинен бути щонайменше через 1 годину",
returnDateRequiredError: "Дата зворотної поїздки обов'язкова",
returnTimeRequiredError: "Час зворотної поїздки обов'язковий",
returnTimeMinOneHourError: "Час зворотної поїздки повинен бути щонайменше через 1 годину",
services: "Додаткові послуги",
  waitingTime: "Час очікування",
  waitingTimeDescription: "Водій чекатиме на вас довше – можна замовити кроками по 15 хвилин.",
  pickupAdjust: "Коригування часу подачі при затримці рейсу",
  pickupAdjustDescription: "Якщо ваш рейс затримується, ми автоматично зсуваємо час подачі – водій чекатиме на вас.",
  waitingFreeIncluded: "{min} хв безкоштовно включено",
  waitingEachExtra: "кожні додаткові {min} хв {price} €",
  flightRequiredForAdjust: "Для замовленого коригування часу подачі вкажіть номер рейсу (напр. LH123).",
  sessionExpiredTitle: "Сесія закінчилась",
  sessionExpiredText: "З міркувань безпеки ви вийшли із системи. Увійдіть знову – ваші дані не втрачено.",
  sessionExpiredButton: "До входу",
  flightHintTitle: "Чи відповідає час подачі часу приземлення?",
  flightHintText: "Ваш рейс {flight} має приземлитися о {landing} – обраний час подачі ({pickup}) раніше. Оберіть час подачі після приземлення:",
  flightHintKeep: "Залишити час подачі {pickup}",
  flightHintChanged: "Час подачі змінено на {time}.",
  flightHintReturnPrefix: "Зворотний шлях",
  tabCancelled: "Скасовані"
};

export default translations;
